module.exports = __webpack_public_path__ + "img/特产店铺2.a6d356b5.png";